<template>
    <div>
        <div class="news-banner">
            <img src="../../assets/images/banner3.png" alt="">
            <!-- <div class="banner_warp">
                <div class="top-text">
                    <p>新闻中心</p>
                    <p>能够及时洞悉公司情况，了解行业发展</p>
                </div>
                <img src="" alt="">
            </div> -->
        </div>


        <!-- 新闻首页内容 -->
        <div class="news_wrap">
            <!-- 公司动态 -->
            <div class="news_trends">
                <p class="new_title">公司动态</p>

                <div id="scroll">
                    <!-- 两侧按钮 -->
                    <!-- <div class="btn_all">
                        <div class="btn_left" @click="scrollMoveLeft()"><img src="../../assets/images/157.png" alt=""></div>
                        <div class="btn_right" @click="scrollMoveRight()"><img src="../../assets/images/158.png" alt=""></div>
                    </div> -->

                    <div class="scroll-img">
                        <div class="scroll-imgs">
                
                 <div class="news_card scroll-card">
                    <router-link to="/invest"><div class="img_allboxs">
                        <img src="../../assets/images/159.png" alt="">
                        <p>司马大大获千万级投资,   投资方为万达投资</p>
                    </div>
                    </router-link>
                </div>
                <!-- 第九个 -->
                <div class="news_cardadd scroll-card">
                    <router-link to="/light"> 
                        <div class="img_allboxs">
                            <img src="../../assets/images/154.png" alt="" style="width: 295px;height: 188px;">
                            <p>数据压缩存储成为“数字中国”亮点 智能庭审系统备受行业瞩目</p>
                        </div>
                    
                    </router-link>
                </div> 
                <!-- 第八个 -->
                <div class="news_cardadd scroll-card">
                    <router-link to="/numbers"> 
                        <div class="img_allboxs">
                            <img src="../../assets/images/94.png" alt="" style="width: 295px;height: 188px;">
                            <p>司马大大发布智能庭审视频数据“冷存储+”解决方案，全面助力数字中国未来发展</p>
                        </div>
                    
                    </router-link>
                </div>                
                <!-- 第3个 -->
                <div class="news_card scroll-card">
                    <router-link to="/training">
                        <div class="img_allboxs">
                            <img src="../../assets/images/16.png" alt="">
                            <p>首次开展合作伙伴公司产品培训</p>
                        </div>
                        
                    </router-link>
                </div>
                <!-- 第2个 -->
                <div class="news_card scroll-card">
                    <router-link to="/contest"> 
                        <div class="img_allboxs">
                            <img src="../../assets/images/15.png" alt="">
                            <p>AI算法组在公安部举办的竞赛中
                            荣获单项总排名第四</p>
                        </div>
                    
                    </router-link>
                </div>
                <!-- 第1个 -->
                <div class="news_card scroll-card">
                    <router-link to="/publish"><div class="img_allboxs">
                        <img src="../../assets/images/14.png" alt="">
                        <p>公司召开2018-2019年度
                        战略合作签约发布会</p>
                    </div>
                    </router-link>
                </div>

                

                        </div>
                    </div>

                </div>

            </div>

            <!-- 媒体访问 行业资讯内容 -->
            <div class="news_downall">
                <!-- 媒体访问 -->
                <div class="news_medium">
                        <p class="new_title">媒体专访</p>
                        <!-- 第4个 -->
                        <div class="news_cards">
                           <router-link to="/book"> 
                            <div class="card_imgs">
                                <img src="../../assets/images/5.png" alt="">
                            </div>
                            <p>《量子大唠嗑》新书发布</p>
                           </router-link>
                        </div>
                        <!-- 第5个 -->
                        <div class="news_cards">
                           <router-link to="/coming"> 
                            <div class="img_allbox"> <img src="../../assets/images/18.png" alt=""></div>
                            <p>奇点大课现场直击“科技驱动未来”</p>
                           </router-link>
                        </div>
                        <!-- 第6个 -->
                        <div class="news_cards">
                            <router-link to="/fruit"> 
                            <div class="img_allbox"><img src="../../assets/images/19.png" alt=""></div>
                            <p>科研成果在艺术家看来都是垃圾？</p>
                             </router-link>
                        </div>
                        <!-- 第7个 -->
                        <div class="news_cards">
                            <router-link to="/scientist"> 
                            <div class="img_allbox"><img src="../../assets/images/20.png" alt=""></div>
                            <p>科学家成“网红”需要正确打开方式</p>
                            </router-link>
                        </div>
                </div>
                <!-- 行业资讯 -->
                <div class="trade">
                    <p class="new_title" style="font-size: 30px; margin-top: -16px;">行业资讯</p>
                    <p> <a @click="linkDownload('http://wap.miit.gov.cn/n4858539/n4858615/n4858686/n4858728/c6559806/content.html?from=groupmessage&isappinstalled=0')">工业和信息化部关于加快推进虚拟现实产业发展的指导意见</a></p>
                    <p>日期：2019-01-30</p>
                    <p class="sml_p">各省、自治区、直辖市及计划单列市、新疆生产建设兵团工业和信息化主管部门，有关行业组织，有关单位:</p>
                    <p class="sml_p">虚拟现实（含增强现实、混合现实，简称VR）融合应用了多媒体、传感器、新型显示、互联网和人工智能等多领域技......</p>
                    <div class="line_border"></div>
                    <ul> 
                        <li><span></span> <a @click="linkDownload('https://mp.weixin.qq.com/s/hg1S5CbqcccD0g5E3sRYiA')">北京安防展浅见一二三</a></li>
                        <li><span></span> <a @click="linkDownload('https://baijiahao.baidu.com/s?id=1623488546775556528&wfr=spider&for=pc')">构建新一代人工智能准则 </a></li>
                        <li><span></span> <a @click="linkDownload('http://news.watchstor.com/news-167487.htm')">安防监控中AI计算机视觉的应用</a></li>
                        <li><span></span> <a @click="linkDownload('https://www.toutiao.com/i6611717828921786884/?tt_from=weixin&utm_campaign=client_share&wxshare_count=5&from=timeline&timestamp=1539425018&app=news_article&utm_source=weixin&isappinstalled=0&iid=45783579028&utm_medium=toutiao_android&group_id=6611717828921786884&pbid=6578801107697927693')"> python人脸识别系统早已开源，离线识别率高达99%以上！</a></li>
                        <li><span></span> <a @click="linkDownload('https://mp.weixin.qq.com/s/pobPP2F3DZwnRP44wLcLXw')">业界 | 李飞飞团队最新研究成果：视觉AI让医院细菌无处可逃</a> </li>
                    </ul> 
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "../../../node_modules/jquery/dist/jquery.js";
import header from "../cuscom/header";
export default {
    // 鼠标滚轮横向滚动
    created: function () {
        var firefox = navigator.userAgent.indexOf('Firefox') != -1
        function MouseWheel(e){
                    e=e||window.event;
                    if(e.stopPropagation){
                      e.stopPropagation();
                    }else{
                      e.cancelBubble=true;
                    }

                    if(e.preventDefault){
                      e.preventDefault();
                    }else{
                      e.returnValue=false;
                }

        if(firefox){
                if(e.detail<0){
                  $('#scroll').scrollLeft($('#scroll').scrollLeft()-60);
                }else{
                  $('#scroll').scrollLeft($('#scroll').scrollLeft()+60);
                }         
              }else{
                if(e.wheelDelta>0){
                  $('#scroll').scrollLeft($('#scroll').scrollLeft()-60);
                }else{
                  $('#scroll').scrollLeft($('#scroll').scrollLeft()+60);
                }
              }
            }

        $(function(){
            var abc= document.getElementById('scroll');
            firefox?abc.addEventListener('DOMMouseScroll',MouseWheel,false):(abc.onmousewheel=MouseWheel);
        });
        


    },

    mounted() {
        function scroll(){
            $(".scroll-img .scroll-imgs").animate({"margin-left":"-60px"},function(){
                $(".scroll-img .scroll-imgs .scroll-card:eq(0)").appendTo($(".scroll-img .scroll-imgs"))
                $(".scroll-img .scroll-imgs").css({"margin-left":0})
            })
            }

        // var interval = setInterval(scroll,5000)
        // if(interval) {
        //      clearInterval(interval)
        // }

    },
    
    methods: {
         linkDownload (url) {
               window.open(url,'_blank') // 新窗口打开外链接
             },
        // 左侧
        scrollMoveLeft() {
            $('#scroll').scrollLeft($('#scroll').scrollLeft()-200);
        },
        // 右侧
        scrollMoveRight() {
            $('#scroll').scrollLeft($('#scroll').scrollLeft()+200);
        }
    },
    beforeRouteEnter: (to, from, next) => {
            next(vm => {
             window.scrollTo(0,0)
            });
        },
}
</script>

<style>
.news-banner {
     width: 100%;
     /* height: 681px; */
 }
 .news-banner img {
     width: 100%;
     height: 100%;
 }
 .banner_warp {
     position: absolute;
     top: 0px;
     left: 19%;
 }
 .top-text {
     width: 570px;
     position: absolute;
     top: 300px;

 }
 .top-text p:nth-child(1) {
     font-size: 40px;
     color: #ffffff;
 }
 .top-text p:nth-child(2) {
     font-size: 19px;
     color: #ffffff;
     margin-top: 10px;
 }

 /* 新闻中心首页内容 */
.news_wrap {
    width: 1200px;
    color: #333;
    margin: 0 auto;
}

/* 公司动态 */
.news_trends {
    margin-top: 80px;
    height: 381px;
    background: #f6f6f6;
    margin-bottom: 20px;
    padding-left: 19px;
    padding-right: 19px;
}

.news_trends #scroll {
    overflow-x: auto;
    overflow: hidden;
}

#scroll::-webkit-scrollbar {
    display: none;
}

#scroll .scroll-img {
    width: 1810px;
    overflow: hidden; 
}
#scroll .scroll-imgs {
    width: 1810px;
}

/* 左右按钮 */
#scroll .btn_all {
    width: 1162px;
    height: 188px;
    position: absolute;
    opacity: 0;
}
#scroll .btn_all:hover {
    opacity: 1;
}
#scroll .btn_left,.btn_right {
    width: 58px;
    height: 188px;
    background: #000;
    opacity: .4;
    position: absolute;
    text-align: center;
}
#scroll .btn_left,.btn_right img {
    padding-top: 70px;
}
#scroll .btn_left {
    left: 0;
}
#scroll .btn_right {
    right: 0;
}

.news_trends .news_cardadd {
    float: left;
    margin-right: 6px;
}

.news_cardadd p {
    color: #000;
    font-size: 18px;
    width: 260px;
    text-align: center;
    margin-left: 20px;
    padding-top: 9px;
}

.new_title {
    font-size: 30px;
    margin-bottom: 26px;
    padding-top: 10px;
}

.news_card p {
    color: #000;
    font-size: 18px;
    width: 260px;
    text-align: center;
    margin-left: 20px;
    padding-top: 9px;
}

.news_card {
    float: left;
    margin-right: 6px;
    /* position: relative; */
}

/* 新闻中心图片过渡 */
.img_allbox {
    width: 295px;
    height:  188px;
    overflow: hidden;
}
.img_allboxs {
    /* position: relative; */
    overflow: hidden;
}
.news_card img {
    width: 295px;
    height:  188px;
    /* transition: all 1s ease-in-out; */
}
/* 
.news_card img:hover {
    position: absolute;
    box-shadow: #646464 0 0 13px;
    transform: translateY(46px) scale(1.5);
} */

/* 动态第四张过渡 */
/* .news_cardadd img {
    transition: all 1s ease-in-out;
}
.news_cardadd img:hover {
    position: absolute;
    box-shadow: #646464 0 0 13px;
    transform: scale(1.5);
} */

/* 下方内容 */
.news_downall {
    height: 586px;
    margin-bottom: 130px;
}

/* 媒体内容 */
.news_medium {
    width: 635px;
    height: 586px;
    padding-left: 20px;
    float: left;
    background: #f6f6f6;
}

/* 媒体过渡 */
.news_cards img {
    transition: all 1s;
}
.news_cards img:hover {
    position: absolute;
    box-shadow: #646464 0 0 15px;
    transform: scale(1.1);
}

/* 媒体第一张过渡 */
.news_cards .card_imgs {
    width: 295px;
    height: 188px;
    background: #000;
    overflow: hidden;
}
.card_imgs img {
    height: 188px;
    margin-left: 70px;
    transition: all 1s;
}
.card_imgs img:hover {
    box-shadow: #646464 0 0 15px;
    transform: scale(1.3);
}

.news_cards {
    margin-right: 6px;
    float: left;
}
.news_cards p {
    color: #000;
    font-size: 18px;
    text-align: center;
    padding-top: 9px;
    margin-bottom: 10px;
}

/* 行业资讯 */
.trade {
    width: 554px;
    height: 586px;
    background: #f6f6f6;
    float: right;
    padding: 15px;
}

.trade p:nth-child(2) {
    color: #333;
    font-size: 18px;
}
.trade p:nth-child(3) {
    color: #bbb;
    font-size: 14px;
    margin-bottom: 8px;
}
.trade .sml_p{
    font-size: 14px;
    text-indent: 2em
}
.trade .line_border {
    border-top: 1px solid #dddddd;
    margin-top: 20px;
}


.trade ul {
    margin-top: 18px;
    margin-bottom: 15px;
}
.trade li {
    list-style: none;
    font-size: 16px; 
    margin-top: 10px;
}
.trade span {
    display: block;
    width: 12px;
    height: 12px;
    background: #000;
    border-radius: 50%;
    float: left;
    margin-right: 13px;
    margin-top: 4px;
}
.trade p {
    font-size: 14px;
}
.trade a {
    color: #333;
}

</style>



// WEBPACK FOOTER //
// src/components/news/news.vue